function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.814 4.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Click to change to view the websites as a list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M82.648 177.353a.51.51 0 0 1 .51-.51H86.9a.51.51 0 1 1 0 1.02h-3.742a.51.51 0 0 1-.51-.51m4.252 1.36h-3.742a.51.51 0 0 0 0 1.022H86.9a.511.511 0 0 0 0-1.021m-.051 1.872h-3.742a.51.51 0 1 0 0 1.02h3.742a.51.51 0 1 0 0-1.02",
    style: {
      strokeWidth: 0.264583
    },
    transform: "translate(-82.597 -176.843)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e623e5726a2ec7836b31bf45e1765095.svg";
export { ForwardRef as ReactComponent };